class SiteHeader {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-siteheader',
            toggleAttr: 'toggle',
            scrollOffset: 40
        };

        this.settings = Object.assign({}, defaults, options);
        this.$siteHeader = $element;
        this.$siteHeaderToggles = this.$siteHeader.querySelectorAll(`[${this.settings.initAttr}="${this.settings.toggleAttr}"]`);
        this.$siteHeaderSearch = this.$siteHeader.querySelector('[data-siteheader="search"]');
        this.$searchToggle = this.$siteHeader.querySelector('#search-toggle');
        this.$searchInput = this.$siteHeader.querySelector('[data-search-bar-input]');
        this.eventScroller = window.eventScroller;
        this.currentScrollPosition = window.scrollY;
        this.backScrolling = false;

        window.setTimeout(() => {
            this.initialize();
        }, 100);
    }

    initialize () {
        this.initToggles();
        this.setEvents();
    }

    setEvents () {
        // close search
        if (this.$siteHeaderSearch) {
            document.addEventListener('keydown', (e) => {
                if (e.code === 'Tab' || e.code === 'Tabs') {
                    if (!this.$siteHeaderSearch.contains(e.target) && this.$searchToggle.checked) {
                        this.$searchToggle.checked = false;
                    }
                }
            });
        }
    }

    initToggles () {
        this.$siteHeaderToggles.forEach($toggle => {
            $toggle.addEventListener('change', () => {
                this.unCheckToggles($toggle);
                this.toggleSearchInputFocus($toggle);
            });
        });
    }

    toggleSearchInputFocus ($activeToggle) {
        if ($activeToggle.checked && $activeToggle === this.$searchToggle) {
            this.$searchInput.focus();
        }

        if (($activeToggle.checked && $activeToggle !== this.$searchToggle) || (!$activeToggle.checked && $activeToggle === this.$searchToggle)) {
            this.$searchInput.blur();
        }
    }

    unCheckToggles ($activeToggle) {
        this.$siteHeaderToggles.forEach($toggle => {
            if ($toggle !== $activeToggle) {
                $toggle.checked = false;
            }
        });
    }
}

export default SiteHeader;
